import { render } from "./HomeGrid.vue?vue&type=template&id=60ca6c3a"
import script from "./HomeGrid.vue?vue&type=script&lang=js"
export * from "./HomeGrid.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__